export const SEARCH_CATEGORIES = {
  all: 'all',
  wallets: 'wallets',
  tradingAccounts: 'tradingAccounts',
  markets: 'markets',
  history: 'history',
} as const;

export type SearchCategory = keyof typeof SEARCH_CATEGORIES;

export const SEARCH_CATEGORIES_ORDER: Array<SearchCategory> = [
  SEARCH_CATEGORIES.all,
  SEARCH_CATEGORIES.wallets,
  SEARCH_CATEGORIES.tradingAccounts,
  SEARCH_CATEGORIES.markets,
  SEARCH_CATEGORIES.history,
];

export const SEARCH_QUICK_OPTIONS = ['ETH', 'Bitcoin'] as const;

export const SEARCH_HISTORY_DATE_FILTER = '3mth';
